import React, { useState } from 'react'
import Joyride, { ACTIONS } from 'react-joyride'
import TourHeaderComponent from './TourHeaderComponent'
import { FormattedMessage, useIntl } from 'react-intl'
import TourBottomComponent from './TourBottomComponent'
import { useTheme } from '@material-ui/core/styles'
import { useMediaQuery } from '@material-ui/core'
const GVA_IMAGE_AI_FIRST_STEP_TOUR = 'GVA_IMAGE_AI_FIRST_STEP_TOUR'
const TOUR_RATE_ENHANCE = 'TOUR_RATE_ENHANCE'

const FirstStep = (props) => {
  const { onClickFinish, onClickNext, onClickSkip } = props
  const { formatMessage } = useIntl()
  const theme = useTheme()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))
  return (
    <div className="flex flex-col">
      <TourHeaderComponent
        text={formatMessage({ id: 'tour.gvaImages.firstStep.title' })}
      ></TourHeaderComponent>
      <div
        className="overflow-y-auto"
        style={{ height: isDownXs ? '350px' : 'auto' }}
      >
        <div className="text-16 bg-white space-y-5 p-5">
          <p className="text-gray-800 text-left">
            <FormattedMessage id={'tour.gvaImages.firstStep.body'} />
          </p>
          <p className="text-gray-800  text-left">
            <span className="font-bold pr-4">
              <FormattedMessage id={'tour.gvaImages.generateImage.title'} />
            </span>
            <FormattedMessage id={'tour.gvaImages.generateImage.body'} />
          </p>
          <p className="text-gray-800 text-left">
            <span className="font-bold pr-4">
              <FormattedMessage
                id={'tour.gvaImages.directImageCreation.title'}
              />
            </span>
            <FormattedMessage id={'tour.gvaImages.directImageCreation.body'} />
          </p>
        </div>
      </div>
      <TourBottomComponent
        numberOfDot={2}
        activeIndex={0}
        onClickFinish={onClickFinish}
        onClickNext={onClickNext}
        onClickSkip={onClickSkip}
      ></TourBottomComponent>
    </div>
  )
}

const SecondStep = (props) => {
  const { onClickFinish, onClickPrevious } = props
  const { formatMessage } = useIntl()
  return (
    <div className="flex flex-col">
      <TourHeaderComponent
        text={formatMessage({ id: 'tour.rateEnhance.firstStep.title' })}
      ></TourHeaderComponent>
      <div className="bg-white p-5">
        <p className="text-gray-800 mb-4 text-left">
          <FormattedMessage id={'tour.rateEnhance.firstStep.firstParagraph'} />
        </p>
        <p className="text-gray-800 mt-16 text-left">
          <FormattedMessage id={'tour.rateEnhance.firstStep.secondParagraph'} />
        </p>
      </div>
      <TourBottomComponent
        numberOfDot={2}
        activeIndex={1}
        onClickFinish={onClickFinish}
        onClickPrevious={onClickPrevious}
      ></TourBottomComponent>
    </div>
  )
}

const GVAImagesAITour = (props) => {
  const { run, onClickFinish, onDismiss } = props
  const [stepIndex, setStepIndex] = useState(0)
  const steps = [
    {
      target: `.${GVA_IMAGE_AI_FIRST_STEP_TOUR}`,
      content: (
        <FirstStep
          onClickNext={() => {
            setStepIndex(1)
          }}
          onClickSkip={onDismiss}
        ></FirstStep>
      ),
      placement: 'right',
      disableBeacon: true,
      hideFooter: true,
      styles: {
        spotlight: {
          height: '37px !important',
        },
        options: {
          width: 500,
        },
      },
    },
    {
      target: `.${TOUR_RATE_ENHANCE}`,
      content: (
        <SecondStep
          onClickFinish={() => {
            setStepIndex(0)
            onClickFinish()
          }}
          onClickPrevious={() => {
            setStepIndex(0)
          }}
        ></SecondStep>
      ),
      placement: 'right',
      disableBeacon: true,
      hideFooter: true,
      styles: {
        options: {
          width: 500,
        },
      },
      disableScrolling: true,
    },
  ]
  const handleCallback = (data) => {
    const { action } = data
    if (action === ACTIONS.CLOSE || action === ACTIONS.RESET) {
      setStepIndex(0)
      onDismiss()
    }
  }
  return (
    <Joyride
      stepIndex={stepIndex}
      callback={handleCallback}
      steps={steps}
      run={run}
      styles={{
        spotlight: {
          height: '37px',
        },
        options: {
          arrowColor: '#fff',
          backgroundColor: '#fff',
          zIndex: 9999,
          padding: '10px !important',
        },
        tooltip: {
          padding: '10px !important',
        },
      }}
      hideBackButton={true}
      disableOverlayClose={true}
      hideCloseButton={true}
    />
  )
}

export default React.memo(GVAImagesAITour)
export { GVA_IMAGE_AI_FIRST_STEP_TOUR, TOUR_RATE_ENHANCE }
